/* eslint-disable */
//noinspection JSUnusedLocalSymbols

import React, { useState } from 'react';
//noinspection ES6CheckImport
import { OutTable } from 'react-excel-renderer';
import { Loader, Menu, Segment } from 'semantic-ui-react';
import * as XLSX from 'xlsx';

// override ExcelRenderer
/* istanbul ignore next */
function make_cols(refstr) {
  let o = [],
    C = XLSX.utils.decode_range(refstr).e.c + 1;
  for (let i = 0; i < C; ++i) {
    o[i] = { name: XLSX.utils.encode_col(i), key: i };
  }
  return o;
}

/* istanbul ignore next */
function ExcelRenderer(file, wsname, callback) {
  return new Promise(function (resolve, reject) {
    let reader = new FileReader();
    let rABS = !!reader.readAsBinaryString;
    reader.onload = function (e) {
      /* Parse data */
      let bstr = e.target.result;
      let wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array' });

      /* Get first worksheet if worksheet Name is not given */
      if (!wsname) {
        wsname = wb.SheetNames[0];
      }
      let ws = wb.Sheets[wsname];

      /* Convert array of arrays */
      let json = XLSX.utils.sheet_to_json(ws, { header: 1 });
      let cols = make_cols(ws['!ref']);

      let data = { rows: json, cols: cols, sheets: wb.SheetNames };

      resolve(data);
      return callback(null, data);
    };
    if (file && rABS) {
      reader.readAsBinaryString(file);
    } else {
      reader.readAsArrayBuffer(file);
    }
  });
}

// End overrite ExcelRenderer

const ExcelFileViewer = (props) => {
  const [loading, setLoading] = useState(false);
  const [cols, setCols] = useState(null);
  const [rows, setRows] = useState(null);
  const [sheets, setSheets] = useState(null);
  const [selectedSheet, setSelectedSheet] = useState(null);

  const renderSheet = (sheetName) => {
    if (sheetName && sheetName === selectedSheet) {
      return;
    }

    setSelectedSheet(sheetName);
    setLoading(true);
    const url = props.fileURL;

    const file = new XMLHttpRequest();
    file.open('GET', url, true);
    file.send();
    file.responseType = 'blob';

    file.onreadystatechange = () => {
      if (file.readyState === 4 && file.status === 200) {
        //noinspection JSIgnoredPromiseFromCall
        ExcelRenderer(file.response, sheetName, (err, resp) => {
          if (err) {
            console.log(err);
          } else {
            setSheets(resp.sheets);
            if (!selectedSheet) {
              setSelectedSheet(resp.sheets[0]);
            }
            setCols(resp.cols);
            setRows(resp.rows);
            setLoading(false);
          }
        });
      }
    };
  };

  React.useEffect(() => {
    renderSheet();
  }, [props.fileURL]);

  return (
    <div className="documentviewer-document-container xlsx">
      <Segment className="documentviewer-document-wrapper xlsx" attached="top">
        <div className="wrapper">
          <Loader active={loading} inline="centered">
            Loading
          </Loader>

          {rows && cols && <OutTable data={rows} columns={cols} withZeroColumn={true} withoutRowNum={false} />}
        </div>
      </Segment>

      <Menu attached="bottom">
        {sheets?.map(function (sheet) {
          return (
            <Menu.Item key={sheet} active={sheet === selectedSheet} onClick={() => renderSheet(sheet)}>
              {sheet}
            </Menu.Item>
          );
        })}
      </Menu>
    </div>
  );
};

export default ExcelFileViewer;
